/** Resolve business id from auth store (handles partial snapshots after signup). */
export function resolveBusinessId(state) {
  if (!state) return null
  return (
    state.businessId ||
    state.user?.business_id ||
    state.business?.id ||
    null
  )
}
